<div class="pt-5 pb-3 text-center">
  <img class="d-block mx-auto mb-4" src="/assets/images/logo-hf-3.png" alt="Hércules Formación">
  <h2>Ficha de Participante en Acciones Formativas</h2>
  <p class="lead">Por favor, rellena el siguiente formulario con tus datos de participante.</p>
</div>

<div *ngIf="submitted" class="alert alert-success text-center mt-3">
  <strong>¡Ficha enviada correctamente!</strong> Gracias por completar tus datos.
</div>

<div class="row g-5" *ngIf="!loading && participant && !submitted">
  <div class="col">
    <form [formGroup]="participantForm" (submit)="save()">

      <h4 class="mb-3">1) Datos personales</h4>
      <ul>
        <li *ngIf="fullName">
          <span>Nombre: </span><span>{{fullName}}</span>
        </li>
        <li *ngIf="participant?.documentNumber">
          <span>DNI: </span><span>{{participant.documentNumber}}</span>
        </li>
      </ul>
      <hr class="my-1">

      <div class="row">
        <div class="col-md-6 mt-4">
          <div class="p-field">
            <span class="p-float-label">
              <input type="text" id="email" class="w-100" pInputText formControlName="email">
              <label for="email">Correo electrónico *</label>
            </span>
          </div>
        </div>
        <div class="col-md-6 mt-4">
          <div class="p-field">
            <span class="p-float-label">
              <input type="text" id="phoneNumber" class="w-100" pInputText formControlName="phoneNumber">
              <label for="phoneNumber">Teléfono</label>
            </span>
          </div>
        </div>
        <div class="col-md-6 mt-4">
          <div class="p-field">
            <span class="p-float-label">
              <input type="text" id="province" class="w-100" pInputText formControlName="province">
              <label for="province">Provincia de residencia *</label>
            </span>
          </div>
        </div>
        <div class="col-md-6 mt-4 d-flex flex-column justify-content-end">
          <label class="form-label mb-1" style="font-size:0.9rem; color:#6c757d;">Fecha de nacimiento</label>
          <div class="d-flex gap-2">
            <input type="number" class="form-control text-center" formControlName="dobDay" placeholder="Día" min="1" max="31" style="width:75px">
            <select class="form-select" formControlName="dobMonth">
              <option [ngValue]="null">Mes</option>
              <option *ngFor="let m of months; let i = index" [ngValue]="i + 1">{{m}}</option>
            </select>
            <input type="number" class="form-control text-center" formControlName="dobYear" placeholder="Año" min="1900" max="2099" style="width:95px">
          </div>
        </div>
        <div class="col-md-6 mt-4">
          <div class="p-field">
            <span class="p-float-label">
              <input type="text" id="profession" class="w-100" pInputText formControlName="profession">
              <label for="profession">Profesión</label>
            </span>
          </div>
        </div>
      </div>

      <hr class="my-3">
      <h4 class="mb-3">2) Nivel de estudios *</h4>
      <div *ngFor="let level of educationLevels" class="form-check mb-2">
        <input class="form-check-input" type="radio" [value]="level.value" formControlName="educationLevel"
          [id]="'edu_' + level.value">
        <label class="form-check-label" [for]="'edu_' + level.value">{{level.label}}</label>
      </div>
      <div *ngIf="isOtherEducation" class="mt-2">
        <span class="p-float-label">
          <input type="text" id="educationLevelOther" class="w-100" pInputText formControlName="educationLevelOther">
          <label for="educationLevelOther">Especificar otros estudios</label>
        </span>
      </div>

      <hr class="my-3">
      <h4 class="mb-3">3) Datos laborales</h4>
      <div class="row">
        <div class="col-md-12 mt-2">
          <div class="p-field">
            <span class="p-float-label">
              <input type="text" id="employer" class="w-100" pInputText formControlName="employer">
              <label for="employer">Empresa donde trabaja *</label>
            </span>
          </div>
        </div>
      </div>
      <div class="mt-3 mb-1"><strong>Nivel de cualificación *</strong></div>
      <div *ngFor="let level of qualificationLevels" class="form-check mb-2">
        <input class="form-check-input" type="radio" [value]="level.value" formControlName="qualificationLevel"
          [id]="'qual_' + level.value">
        <label class="form-check-label" [for]="'qual_' + level.value">{{level.label}}</label>
      </div>

      <hr class="my-4">
      <div class="form-check mb-3">
        <input class="form-check-input" type="checkbox" formControlName="participantConsent" id="participantConsent">
        <label class="form-check-label" for="participantConsent">
          De acuerdo con el RD 694/2017, que desarrolla la Ley 30/2015 que regula el Sistema de Formación Profesional
          para el Empleo en el ámbito laboral, el alumno da su conformidad para participar en nuestras acciones
          formativas. *
        </label>
      </div>
      <div class="form-check mb-3">
        <input class="form-check-input" type="checkbox" formControlName="whatsappAccept" id="whatsappAccept">
        <label class="form-check-label" for="whatsappAccept">
          Autorizo el uso de WhatsApp y otros medios de mensajería móvil como medio de contacto. *
        </label>
      </div>

      <hr class="my-4">
      <button type="submit" class="w-100 btn btn-primary btn-lg" [disabled]="saving">
        {{saving ? 'Enviando...' : 'Enviar ficha'}}
      </button>
    </form>
  </div>
</div>
